import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/lib/contact";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      data-testid="whatsapp-float-button"
      aria-label="Chat with PK Hygiene on WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:bg-[#1eb857] hover:scale-110 transition-[background-color,transform] duration-300"
    >
      <MessageCircle className="w-6 h-6" />
    </motion.a>
  );
}
